export default __webpack_public_path__ + "8ffd451f0d8dd8a13c14c819154955e6.png";